/**
 * Hebrew Dashboard Content - UI strings for Hebrew dashboard at /he/dashboard
 * This file contains all translatable strings for the dashboard interface.
 */
window.HebrewDashboardContent = {
    // ==========================================
    // HEADER & NAVIGATION
    // ==========================================
    header: {
        dashboard: "לוח בקרה",
        responses: "תשובות",
        myForms: "הטפסים שלי",
        signOut: "התנתק",
        upgrade: "שדרג",
        free: "חינם",
        basic: "אירוע פרו",
        premium: "Signature",
        viewOnly: "צפייה בלבד"
    },

    // ==========================================
    // TAB NAVIGATION
    // ==========================================
    tabs: {
        responses: "תשובות",
        analytics: "ניתוח נתונים",
        campaigns: "הודעות לאורחים",
        export: "ייצוא"
    },

    // ==========================================
    // RESPONSES TAB
    // ==========================================
    responses: {
        title: "תשובות",
        totalResponses: "סך הכל תשובות",
        attending: "מגיעים",
        notAttending: "לא מגיעים",
        maybe: "אולי",
        adults: "מבוגרים",
        children: "ילדים",
        searchPlaceholder: "חפש לפי שם, אימייל או טלפון...",
        filterAll: "כל התשובות",
        filterYes: "כן - מגיעים",
        filterNo: "לא - לא מגיעים",
        filterMaybe: "אולי",
        noResponses: "עדיין אין תשובות",
        noResponsesDesc: "התשובות יופיעו כאן כאשר האורחים יאשרו הגעה.",
        shareFirstDesc: "שתפו את הקישור עם האורחים – התשובות שלהם יופיעו כאן.",
        sendInvitations: "שליחת הזמנות",
        copyLink: "העתקת קישור",
        generalLink: "קישור כללי",
        personalLinks: "קישורים אישיים",
        loading: "טוען תשובות...",
        deleteConfirm: "האם אתה בטוח שברצונך למחוק תשובה זו?",
        deleteSuccess: "התשובה נמחקה בהצלחה",
        saveSuccess: "השינויים נשמרו בהצלחה",
        saveError: "שגיאה בשמירת השינויים"
    },

    // ==========================================
    // TABLE HEADERS
    // ==========================================
    table: {
        name: "שם",
        email: "אימייל",
        phone: "טלפון",
        attending: "הגעה",
        guestCount: "אורחים",
        dietary: "תזונה",
        relationship: "קשר",
        message: "הודעה",
        submittedAt: "תאריך שליחה",
        actions: "פעולות",
        yes: "כן",
        no: "לא",
        maybe: "אולי"
    },

    // ==========================================
    // ANALYTICS TAB
    // ==========================================
    analytics: {
        title: "סטטיסטיקות אירוע",
        responseRate: "שיעור תגובה",
        totalInvited: "סה\"כ מוזמנים",
        totalResponded: "סה\"כ ענו",
        pending: "ממתינים",
        attendanceBreakdown: "התפלגות הגעה",
        guestBreakdown: "התפלגות אורחים",
        responseTimeline: "ציר זמן תגובות",
        dietaryPreferences: "העדפות תזונתיות",
        relationships: "קשרים",
        setupTracking: "הגדר מעקב",
        setupTrackingDesc: "הכנס את מספר ההזמנות שנשלחו כדי לראות סטטיסטיקות שיעור תגובה.",
        invitationsSent: "הזמנות שנשלחו",
        manualCount: "ספירה ידנית",
        autoDetection: "זיהוי אוטומטי",
        switchToAuto: "לעבור לזיהוי אוטומטי?",
        noAnalyticsYet: "אין סטטיסטיקות זמינות עדיין",
        noAnalyticsDesc: "הסטטיסטיקות יופיעו כשתקבל תשובות."
    },

    // ==========================================
    // CAMPAIGNS TAB
    // ==========================================
    campaigns: {
        title: "הודעות",
        newCampaign: "שליחת הודעות",
        sendInvitations: "שלח הזמנות",
        campaignHistory: "היסטוריית הודעות",
        noCampaigns: "מוכן להזמין אורחים?",
        noCampaignsDesc: "שלח הזמנות מותאמות אישית במייל או בוואטסאפ. אנו נעקוב מי פתח וענה.",
        createFirst: "שלח הזמנות",
        contactStatus: "סטטוס אנשי קשר",
        sendReminder: "שלח תזכורת",
        scheduledReminders: "תזכורות מתוזמנות",
        credits: "קרדיטים",
        buyCredits: "קנה קרדיטים",
        messagesSent: "הודעות נשלחו",
        delivered: "נמסרו",
        opened: "נפתחו",
        clicked: "הוקלקו",
        responded: "ענו",
        pending: "ממתינים"
    },

    // ==========================================
    // CAMPAIGN WIZARD
    // ==========================================
    wizard: {
        title: "שלח הזמנות",
        step1: "אנשי קשר",
        step2: "סקירה",
        step3: "שליחה",
        addContacts: "הוסף אנשי קשר",
        importFromFile: "ייבא מקובץ",
        pasteContacts: "הדבק אנשי קשר",
        manualEntry: "הזנה ידנית",
        uploadCSV: "העלה CSV",
        uploadVCard: "העלה vCard",
        dragDropHere: "גרור קבצים לכאן או לחץ לחיפוש",
        supportedFormats: "פורמטים נתמכים: CSV, VCF (vCard)",
        contactsAdded: "אנשי קשר נוספו",
        reviewContacts: "סקור אנשי קשר",
        removeSelected: "הסר נבחרים",
        selectAll: "בחר הכל",
        deselectAll: "בטל בחירה",
        messageTemplate: "תבנית הודעה",
        personalizeMessage: "התאם אישית הודעה",
        previewMessage: "תצוגה מקדימה",
        sendVia: "שלח דרך",
        email: "אימייל",
        whatsapp: "וואטסאפ",
        both: "שניהם",
        schedule: "תזמן",
        sendNow: "שלח עכשיו",
        scheduleLater: "תזמן לאחר כך",
        confirmSend: "אשר שליחה",
        sending: "שולח...",
        sent: "נשלח",
        failed: "שגיאה",
        cancel: "ביטול",
        back: "חזור",
        next: "הבא",
        finish: "סיים"
    },

    // ==========================================
    // EXPORT TAB
    // ==========================================
    export: {
        title: "ייצא נתונים",
        exportCSV: "ייצא ל-CSV",
        exportLanguage: "שפת ייצוא",
        original: "מקורי (ללא תרגום)",
        selectLanguage: "בחר שפה...",
        exportAll: "ייצא הכל",
        exportFiltered: "ייצא מסונן",
        downloading: "מוריד...",
        downloadComplete: "הורדה הושלמה",
        noDataToExport: "אין נתונים לייצוא"
    },

    // ==========================================
    // MODALS
    // ==========================================
    modals: {
        editResponse: "ערוך תשובה",
        deleteResponse: "מחק אורח",
        confirmDelete: "האם אתה בטוח שברצונך למחוק תשובה זו? פעולה זו אינה הפיכה.",
        sendReminder: "שלח תזכורת חכמה",
        reminderDesc: "הנמענים מסוננים על סמך מעקב הודעות.",
        recipients: "נמענים",
        customMessage: "הודעה מותאמת אישית (אופציונלי)",
        customMessagePlaceholder: "הוסף הערה אישית...",
        scheduledReminders: "הגדר תזכורות מתוזמנות",
        enableReminders: "אפשר תזכורות מתוזמנות",
        reminderTiming: "מתי לשלוח תזכורות:",
        oneDay: "יום לפני",
        threeDays: "3 ימים לפני",
        oneWeek: "שבוע לפני",
        twoWeeks: "שבועיים לפני",
        contactStatus: "סטטוס אנשי קשר",
        allContacts: "כל אנשי הקשר",
        respondedFilter: "ענו",
        pendingFilter: "ממתין לתשובה",
        doubleResponse: "תשובה כפולה ⚠️",
        emailStatus: "סטטוס אימייל",
        whatsappStatus: "סטטוס וואטסאפ",
        translating: "מתרגם תשובות",
        translatingTo: "מתרגם תשובות ל"
    },

    // ==========================================
    // USER EVENTS
    // ==========================================
    events: {
        myEvents: "האירועים שלי",
        noEvents: "לא נמצאו אירועים",
        noEventsDesc: "עדיין לא יצרת טופס RSVP.",
        createFirst: "צור את האירוע הראשון שלך",
        created: "נוצר",
        eventId: "מזהה אירוע",
        viewResponses: "צפה בתשובות",
        loadingEvents: "טוען את האירועים שלך...",
        errorLoading: "שגיאה בטעינת אירועים"
    },

    // ==========================================
    // AUTH
    // ==========================================
    auth: {
        signIn: "התחבר",
        signInDesc: "התחבר כדי לראות את הטפסים שלך",
        signInPrompt: "התחבר לגישה",
        loginWithEmail: "התחבר עם אימייל",
        loginWithGoogle: "המשך עם גוגל",
        loginWithApple: "המשך עם אפל",
        or: "או",
        noAccount: "אין חשבון?",
        createAccount: "צור חשבון"
    },

    // ==========================================
    // COMMON
    // ==========================================
    common: {
        loading: "טוען...",
        save: "שמור",
        cancel: "ביטול",
        close: "סגור",
        delete: "מחק",
        edit: "ערוך",
        confirm: "אשר",
        send: "שלח",
        search: "חיפוש",
        filter: "סנן",
        refresh: "רענן",
        backToEvents: "חזור לאירועים שלי",
        backToAccess: "חזור לאפשרויות גישה",
        selectEvent: "בחר אירוע",
        selectEventDesc: "אנא בחר אירוע ספציפי מהתפריט למעלה.",
        error: "שגיאה",
        success: "הצלחה",
        warning: "אזהרה",
        info: "מידע",
        guests: "אורחים"
    },

    // ==========================================
    // UPGRADE PROMPTS
    // ==========================================
    upgrade: {
        unlockResponses: "פתח את כל התשובות",
        freeLimit: "ניתן לראות עד 25 תשובות.",
        upgradeForUnlimited: "שדרג לצפייה ללא הגבלה →",
        upgradeRequired: "נדרש שדרוג"
    },

    // ==========================================
    // ANALYTICS INSIGHTS (Dynamic JS Content)
    // ==========================================
    insights: {
        // Pattern Insights
        peakResponseDay: "יום שיא בתשובות",
        peakResponseTime: "שעת שיא בתשובות",
        responseMomentum: "מומנטום תשובות",
        attendanceRate: "שיעור הגעה",
        daysUntilEvent: "ימים עד האירוע",
        eventDay: "יום האירוע",

        // Velocity labels
        pickingUp: "מתגבר",
        slowingDown: "מאט",
        steadyPace: "קצב יציב",
        responsesComing: "תשובות מגיעות מהר יותר לאחרונה",
        responseDecreased: "קצב התשובות ירד",
        consistentRate: "קצב תשובות עקבי",

        // Smart Insights
        excellentResponseRate: "שיעור תגובה מצוין",
        lowResponseRate: "שיעור תגובה נמוך",
        highGuestMultiplier: "מכפיל אורחים גבוה",
        lowerGuestImpact: "השפעת אורחים נמוכה",
        attendanceConcerns: "חששות הגעה",
        strongAttendance: "מחויבות הגעה חזקה",

        // Insight descriptions
        respondedWellAbove: "מהאורחים ענו - הרבה מעל הממוצע!",
        onlyResponded: "רק ענו. שקול לשלוח תזכורות.",
        guestImpact: "השפעת אורחים - אנשים מביאים מלווים!",
        ensureVenue: "וודא שהמקום והקייטרינג ערוכים לכמות גדולה יותר.",
        fewerPlusOnes: "השפעת אורחים מרמזת על פחות מלווים מהצפוי.",
        encourageCompanions: "שקול לעודד אורחים להביא מלווים.",
        respondentsAttending: "מהעונים מתכוונים להגיע.",
        investigateBarriers: "בדוק התנגשויות או בעיות עם התאריך/מיקום.",
        showsStrongInterest: "שיעור ההגעה מראה עניין חזק באירוע שלך!",

        // Activity insights
        greatMomentum: "מומנטום נהדר!",
        activeResponses: "תשובות פעילות",
        recentActivity: "פעילות אחרונה",
        responsesThisWeek: "תשובות השבוע בקצב עולה",
        responsesLast7Days: "תשובות ב-7 הימים האחרונים - מעורבות טובה",
        responseInLast: "תשובה/ות ב-7 הימים האחרונים",

        // Prediction
        expectedFinalAttendance: "צפי הגעה סופי",
        projecting: "צופה",
        totalGuests: "אורחים סה\"כ בהתבסס על מגמות",
        highConfidence: "ביטחון גבוה",
        moderateConfidence: "ביטחון בינוני",
        earlyEstimate: "הערכה מוקדמת",
        getMoreResponses: "השג יותר תשובות לשיפור הדיוק",

        // Event countdown
        finalCountdown: "ספירה לאחור סופית!",
        comingSoon: "בקרוב",
        timeToPrepare: "זמן להתכונן",
        daysRemaining: "ימים נותרו",
        eventIsToday: "האירוע שלך היום!",

        // Additional insights
        highResponseVelocity: "מהירות תגובה גבוהה",
        responsesLast24h: "תשובות ב-24 שעות האחרונות מרמזות על מעורבות חזקה",
        optimalCommunicationDay: "יום תקשורת אופטימלי",
        showsResponses: "מראה",
        ofResponses: "מהתשובות - אידיאלי למעקב",
        scheduleRemindersOn: "תזמן תזכורות עתידיות למקסימום תגובות",
        slowResponseCollection: "איסוף תשובות איטי",
        averagingResponses: "ממוצע של",
        responsesPerDay: "תשובות ליום ב-",
        days: "ימים",
        considerDeadline: "שקול לשלוח הודעות דחיפות או תמריצים לזירוז",
        timeForFollowUp: "זמן למעקב",
        noResponsesIn: "אין תשובות ב-",
        reminderCouldBoost: "ימים - תזכורת עשויה להגביר מעורבות",

        // Engagement insights
        highDetailEngagement: "מעורבות גבוהה בפרטים",
        providedDietary: "סיפקו מידע תזונתי - אורחים מעורבים מאוד",
        groupEventPattern: "דפוס אירוע קבוצתי",
        bringingPeople: "אורחים מביאים",
        peopleOnAverage: "אנשים בממוצע - תכנן לקבוצות",
        ensureSeating: "הבטח מקומות ישיבה וקייטרינג לקבוצות",
        lowFieldCompletion: "השלמת שדות נמוכה",
        hasLowCompletion: "יש השלמה נמוכה",
        haveLowCompletion: "יש השלמה נמוכה",
        considerRequired: "שקול להפוך שדות מפתח לחובה",

        // Final week
        finalWeekPush: "דחיפה אחרונה נדרשת",
        eventIn: "אירוע בעוד",
        daysWithOnly: "ימים עם רק",
        responseRateLabel: "שיעור תגובה",
        attendanceRateLabel: "שיעור הגעה",
        sendUrgentReminder: "שלח תזכורת דחופה אחרונה למקסום אישורים",
        finalPlanningWindow: "חלון תכנון סופי",
        daysLeft: "ימים נותרו - זמן לספירה סופית ולוגיסטיקה",
        finalizeCatering: "סגור כמויות קייטרינג ושלח פרטים למאשרים",

        // Chart Labels
        adults: "מבוגרים",
        children: "ילדים",
        guests: "אורחים",
        dietary: "דרישות תזונתיות",
        relationship: "קשר",
        attending: "מגיעים",
        maybe: "אולי",
        notAttending: "לא מגיעים",
        noResponse: "אין תשובה",

        // Activity
        someone: "מישהו",
        confirmedAttendance: "אישר הגעה",
        declined: "סירב",
        fromBulk: "מהודעות",
        manual: "ידני",
        fromBulkMessaging: "מהודעות המוניות",
        clickToAdjust: "לחץ להתאמה",
        sendBulkToUnlock: "שלח הודעות כדי לפתוח מדד זה",
        guestsConfirmed: "אורחים אושרו מתוך",
        invitations: "הזמנות",
        day: "יום",
        untilEvent: "עד האירוע",

        // Saturation
        responseSaturation: "הושגה רווית תשובות",
        patternSuggests: "הדפוס מרמז שתפסת את רוב התשובות הזמינות",

        // Live Activity
        liveUpdates: "עדכונים חיים",
        live: "חי",
        reached: "הושגו",
        responses: "תשובות!",
        latest: "אחרון",
        connecting: "מתחבר",
        offline: "לא מחובר",

        // Day names
        sunday: "ראשון",
        monday: "שני",
        tuesday: "שלישי",
        wednesday: "רביעי",
        thursday: "חמישי",
        friday: "שישי",
        saturday: "שבת",

        // Time ranges
        morning: "בוקר (6:00-12:00)",
        afternoon: "צהריים (12:00-18:00)",
        evening: "ערב (18:00-22:00)",
        night: "לילה (22:00-6:00)",

        // Yes/No/Maybe
        yes: "כן",
        no: "לא",
        maybe: "אולי",

        // Smart insights empty state
        smartInsightsWillAppear: "תובנות חכמות יופיעו כשיגיעו עוד תשובות..."
    },

    // ==========================================
    // BULK SHARING WIZARD (Full UI)
    // ==========================================
    bulkWizard: {
        // Builder-mount success screen (first send from the Share step).
        remindersOnDashboard: "תזכורות, סטטוס משלוח ומעקבים נמצאים בלוח הבקרה.",
        goToDashboard: "פתח את לוח הבקרה",
        outcomeScheduledTitle: "ההודעה תוזמנה",
        outcomeScheduledBody: "ההודעה שלכם תישלח ב-{date}.",
        outcomeApprovalTitle: "ממתינים לאישור של WhatsApp",
        outcomeApprovalBody: "WhatsApp בודק כל הודעה חדשה לפני שהיא יוצאת, בדרך כלל תוך כמה דקות. האורחים שלכם ב-WhatsApp יקבלו אותה ברגע שתאושר, ואין צורך לעשות שום דבר נוסף.",
        outcomeApprovalOthersSent: "אורחים שמקבלים אותה באימייל או ב-SMS כבר מקבלים אותה עכשיו.",
        outcomeHeldTitle: "ההודעה הראשונה שלכם בבדיקה",
        outcomeHeldBody: "זו בדיקה חד-פעמית בשליחה הראשונה. נשלח לכם אימייל ברגע שהיא תשוחרר. שום דבר לא נשלח ולא נוצלו קרדיטים.",
        outcomeRefusedTitle: "WhatsApp לא אישר את ההודעה הזו",
        outcomeRefusedReason: "הסיבה של WhatsApp: {reason}",
        outcomeRefusedOthersNow: "אורחים שמקבלים אותה באימייל או ב-SMS עדיין מקבלים אותה.",
        outcomeRefusedOthersScheduled: "אורחים שמקבלים אותה באימייל או ב-SMS יקבלו אותה בכל זאת ב-{date}.",
        outcomeRefusedNoOthers: "ההודעה עדיין לא נשלחה לאף אחד מהאורחים שלכם.",
        outcomeRefusedFix: "כדי להגיע לאורחים ב-WhatsApp, ערכו את ההודעה מלוח הבקרה ושלחו אותה שוב. WhatsApp יבדוק את הנוסח החדש.",
        tplErr_trailingParam: "ההודעה לא יכולה להסתיים בתגית התאמה אישית כמו {{name}} או {{table_number}}. WhatsApp לא מאפשר זאת. הוסיפו מילה או נקודה אחרי התגית ושלחו שוב.",
        tplErr_waLink: "WhatsApp לא מאפשר כפתור שמקשר חזרה ל-WhatsApp. כוונו את הכפתור למקום אחר ושלחו שוב.",
        tplErr_imageFormat: "בשביל WhatsApp, תמונת ההזמנה צריכה להיות JPG או PNG. העלו אותה שוב בפורמט הזה ושלחו שוב.",
        tplErr_imageProcess: "WhatsApp לא הצליח לעבד את תמונת ההזמנה. נסו תמונה אחרת (JPG או PNG, עד 5MB) ושלחו שוב.",
        tplErr_category: "WhatsApp מסווג את ההודעה כסוג אחר מזה שתייקנו אותה תחתיו. שלחו שוב וזה אמור לעבור.",
        tplErr_layout: "WhatsApp לא הצליח לקרוא את מבנה ההודעה. בדרך כלל זו {{תגית}} שעומדת לבד בשורה משלה. שלבו אותה בתוך משפט ושלחו שוב.",
        tplErr_duplicateName: "ב-WhatsApp כבר שמורה הודעה בשם הזה. שנו את שם ההודעה ושלחו שוב.",
        tplErr_rateLimit: "הגעתם כרגע למגבלה של WhatsApp על הודעות חדשות. המתינו מעט ושלחו שוב. שום דבר לא אבד.",
        outcomeSubmitFailedTitle: "עדיין לא הצלחנו לשלוח את ההודעה ל-WhatsApp לאישור",
        close: "סגירה",
        outcomeSubmitFailedBody: "ננסה שוב באופן אוטומטי ונשלח לכם אימייל אם WhatsApp ידחה אותה. כרגע אין צורך לעשות דבר.",
        outcomeVerifyTitle: "אשרו את כתובת האימייל כדי לשלוח",
        outcomeVerifyBody: "ההודעה שמורה, אבל עדיין לא נשלח דבר. אשרו את כתובת האימייל שלכם (בלשונית השיתוף של הטופס) והיא תישלח אוטומטית.",
        outcomeUpgradeTitle: "נדרש שדרוג לפני השליחה",
        outcomeUpgradeBody: "האירוע הזה משתמש בתכונות מהתבנית שדורשות שדרוג. שדרגו אותו מלוח הבקרה שלו וההודעה תישלח אוטומטית. עדיין לא נשלח דבר.",
        outcomePausedTitle: "ההודעה שלכם עדיין לא נשלחה",
        outcomePausedBody: "היא שמורה, אבל עדיין לא נשלח דבר. אפשר לראות את הסטטוס שלה בלוח הבקרה.",
        sendBlockedBlanks: "בהודעה עדיין יש שדות מהתבנית שצריך למלא: {blanks}",
        sendDateMissing: "בחרו תאריך להודעה המתוזמנת.",
        sendDatePast: "התאריך והשעה שנבחרו כבר עברו. בחרו מועד עתידי.",
        // Initial loading
        checkingAccess: "בודק הרשאות גישה...",
        wizardFailedToLoad: "אשף ההודעות לא נטען. אנא רענן את הדף.",

        // Progress steps
        step1Contacts: "1. אנשי קשר",
        step2Channels: "2. ערוצים",
        step2Review: "3. התאמה אישית",
        step3FollowUp: "4. מעקב",
        step4Send: "5. שליחה",

        // Navigation buttons
        previous: "הקודם",
        next: "הבא",
        nextChannels: "הבא: ערוצי שליחה",
        nextCustomize: "הבא: התאמה אישית",
        nextFinalize: "הבא: סיום ושליחה",
        skip: "דלג",
        saveAsDraft: "שמור כטיוטה",

        // Contacts step
        uploadContactList: "העלה רשימת אנשי קשר",
        uploadContactsDesc: "העלה אנשי קשר בפורמט CSV או vCard",
        dragDropFile: "גרור ושחרר קובץ לכאן",
        orClickToBrowse: "או לחץ לעיון",
        chooseFile: "בחר קובץ",
        csvOrVcard: "CSV או vCard (.vcf)",
        manuallyAddContacts: "הוסף אנשי קשר ידנית",
        csvTemplate: "תבנית CSV",
        vcardTemplate: "תבנית vCard",

        // Phone tip
        phoneTip: "מספרי טלפון חייבים לכלול קידומת מדינה (לדוגמה, +972501234567). אם משתמשים באקסל, עצב את העמודה כ'טקסט' למניעת בעיות עיצוב.",

        // Sending method
        sendVia: "שלח דרך",
        channelEmail: "אימייל",
        channelEmailTooltip: "שלח באימייל. אם אין אימייל, ישתמש בנייד.",
        channelMobile: "נייד (WhatsApp/SMS)",
        channelMobileTooltip: "שלח בוואטסאפ, עם SMS כגיבוי. אם אין טלפון, ישתמש באימייל.",
        channelHint: "קרדיט אחד לכל ערוץ. המערכת עוברת לערוצים אחרים אם המסירה נכשלת.",
        deliveryMethod: "אופן המשלוח",
        smartDeliveryLabel: "משלוח חכם",
        smartDeliveryShortDesc: "WhatsApp/SMS כשזמין, אחרת אימייל.",
        smartDeliveryCreditNote: "קרדיט אחד לאיש קשר.",
        customizeDelivery: "התאמה אישית",
        channelsStepTitle: "בדקו את ערוצי השליחה",
        channelsStepSubtitle: "בחרו כיצד האורחים שלכם יקבלו את ההזמנה.",
        usNumbersDeliveryNote: "🇺🇸 הערה על מספרים אמריקאיים: מטא אינה תומכת בשליחת WhatsApp בכמות גדולה למספרים אמריקאיים, ולכן הם יישלחו אוטומטית כהודעת SMS רגילה. מספרים קנדיים מתחילים גם הם ב־‎+1 אבל לא מושפעים: הם מקבלים WhatsApp. אם האורחים שלכם בעלי מספרים אמריקאיים נמצאים כעת בחוץ לארץ, מומלץ מאוד להוסיף עבורם כתובת אימייל כדי להבטיח שההזמנה תתקבל.",
        deliveryModalTitle: "איך לשלוח את ההזמנות?",
        deliveryOptionSmart: "משלוח חכם",
        deliveryOptionSmartTag: "מומלץ",
        deliveryOptionSmartDesc: "WhatsApp לאנשי קשר מחוץ לארה\"ב, SMS לאנשי קשר בארה\"ב, ואימייל לאנשי קשר ללא טלפון. קרדיט אחד לאיש קשר.",
        deliveryOptionEmail: "אימייל תחילה",
        deliveryOptionEmailDesc: "מעדיף שליחה באימייל. משתמש אוטומטית בנייד אם לא סופק אימייל.",
        deliveryOptionMobile: "נייד תחילה",
        deliveryOptionMobileDesc: "מעדיף שליחה בנייד (WhatsApp/SMS). משתמש אוטומטית באימייל אם לא סופק מספר טלפון.",
        deliveryOptionBoth: "שני הערוצים",
        deliveryOptionBothDesc: "שליחה גם באימייל וגם בנייד כששניהם זמינים.",
        deliveryOptionBothCost: "קרדיט אחד לכל איש קשר, גם בשני הערוצים.",
        deliveryDoneBtn: "שמור",
        deliveryCancelBtn: "ביטול",
        usWhatsappShortNotice: "WhatsApp המוני אינו מותר למספרים בארה\"ב (מדיניות Meta).",

        // SMS consent
        consentNotice: "ייתכנו חיובי הודעות ונתונים לאורחים (התדירות משתנה); הם יכולים להשיב STOP לביטול, HELP לעזרה.",
        usWhatsappNotice: "בהתאם למדיניות Meta הנוכחית, מספרי טלפון בארה\"ב אינם יכולים לקבל הודעות WhatsApp המוניות, ויועברו אוטומטית ל-SMS. עדיין ניתן לשלוח הודעות למספרים בארה\"ב בנפרד דרך WhatsApp.",
        smsConsentCheckbox: "אני מאשר שכל הנמענים הסכימו לקבל הודעות SMS של הזמנה לאירוע שלי דרך QuikRSVP.",
        smsConsentDisclosure: "הנמענים יכולים להשיב STOP לביטול או HELP לעזרה. עלולים לחול חיובי הודעות ונתונים. תדירות משתנה.",
        smsConsentRequired: "עליך לאשר את הסכמת הנמענים לפני השליחה.",
        termsConsentRequired: "יש לאשר את תנאי השימוש ואת מדיניות הפרטיות לפני השליחה.",
        smsConsentEmailFallbackHint: "אין כתובת אימייל עבור {n} מהאורחים שלך, ולכן ההודעה תישלח לטלפון שלהם, ייתכן כהודעת SMS.",
        smsConsentEditTitle: "אישור הסכמה לקבלת SMS",
        smsConsentEditBody: "לחלק מהאורחים בהודעה הזו יש מספרים אמריקאיים, מספרים אחרים עם קידומת המדינה 1 (כמו קנדה) או מספרים מברזיל, ולכן ייתכן שיקבלו אותה כהודעת SMS. יש לאשר את הסכמתם כדי לשמור את השינויים.",
        smsConsentEditSave: "אישור ושמירה",
        termsLink: "תנאי שימוש",
        privacyLink: "מדיניות פרטיות",

        // Contact summary
        valid: "תקינים",
        invalid: "לא תקינים",
        messages: "הודעות",
        editContacts: "ערוך אנשי קשר",
        invalidContacts: "אנשי קשר לא תקינים:",

        // Follow-up banner
        followUpCampaign: "הודעת מעקב",
        contactsAutoLoaded: "אנשי קשר נטענו אוטומטית מההודעה הקודמת שלך.",
        filterApplied: "מסנן הוחל:",
        startFresh: "התחל מחדש",

        // File parsing
        dragDropCsv: "גרור ושחרר קובץ CSV לכאן או לחץ לעיון",
        dragDropVcard: "גרור ושחרר קובץ vCard לכאן או לחץ לעיון",
        csvColumns: "עמודות: שמות האורחים, שם הקבוצה, טלפון, אימייל (אופציונלי: מקס' אורחים, תגיות)",
        downloadCsvTemplate: "הורד תבנית CSV",
        downloadVcardTemplate: "הורד תבנית vCard",
        vcardFromSources: "קובץ .vcf סטנדרטי ממקורות כמו אנשי קשר של גוגל או אאוטלוק.",

        // Send step
        readyToSend: "מוכן לשליחה!",
        reviewAndSend: "סקור את פרטי ההודעה שלך ושלח את ההזמנות.",
        campaignSummary: "סיכום הודעה",
        totalMessages: "סה\"כ הודעות",
        emailLabel: "אימייל",
        mobileLabel: "נייד",

        // Reminders
        remindersEnabled: "תזכורות מופעלות:",

        // Credits
        messageCredits: "קרדיטים להודעות",
        yourBalance: "היתרה שלך",
        creditsNeeded: "קרדיטים נדרשים",
        readyToSendCredits: "מוכן לשליחה! יש לך מספיק קרדיטים להודעה זו.",
        needMoreCredits: "אתה צריך עוד קרדיטים.",
        purchasePackage: "רכוש חבילה להמשך.",

        // Send timing
        sendTiming: "תזמון שליחה",
        sendImmediately: "שלח מיד",
        messagesQueuedNow: "ההודעות ייכנסו לתור מיד",
        scheduleForLater: "תזמן לאחר כך",
        chooseDateTime: "בחר תאריך ושעה ספציפיים",
        date: "תאריך",
        time: "שעה",
        schedulingNote: "זמן המסירה הוא משוער ואינו מובטח. ההודעות ייכנסו לתור לעיבוד בזמן המתוזמן.",

        // Buttons
        sendCampaign: "שליחה לאורחים",
        upgradeAndBuyCredits: "שדרג ורכוש קרדיטים",
        buyCredits: "רכוש קרדיטים",

        // Credits info
        creditsInfo: "הקרדיטים נספרים לפי אורח, לא לפי הודעה • קרדיטים לא פגים לעולם • עובדים בכל הטפסים",
        // Send step: guests per channel and the one cost line (_deliveryPlanHtml).
        deliveryPlanTitle: "איך האורחים יקבלו את ההודעה",
        deliveryWhatsapp: "WhatsApp",
        deliverySms: "הודעת טקסט (SMS)",
        deliveryEmail: "אימייל",
        deliveryGuestsOne: "אורח אחד",
        deliveryGuestsMany: "{n} אורחים",
        deliveryFullDesc: "ההודעה המלאה, כולל תמונה וכפתורים אם הוספתם",
        deliverySmsDesc: "טקסט בלבד: בלי תמונה ובלי כפתורים. הקישורים נשלחים ככתובות אינטרנט.",
        deliverySmsDescNoLink: "טקסט בלבד: בלי תמונה, כפתורים או קישורים.",
        deliverySmsWhy: "מספרים בארה\"ב מקבלים SMS, כי WhatsApp לא מעביר הזמנות כאלה למספרים בארה\"ב.",
        deliverySmsPreview: "הצגת ה-SMS שהם יקבלו",
        deliverySmsCantSend: "האורחים האלה לא יקבלו SMS: הודעת SMS יכולה להכיל רק אותיות לטיניות, ובהודעה הזו אין כאלה. כדי להגיע אליהם, הוסיפו גרסה באנגלית להודעה בשלב ההתאמה האישית.",
        deliverySmsEmailOnlyOne: "לאחד מהם יש כתובת אימייל, והוא יקבל רק את האימייל.",
        deliverySmsEmailOnlyMany: "ל-{n} מהם יש כתובת אימייל, והם יקבלו רק את האימייל.",
        deliverySmsNothingOne: "אורח אחד לא יקבל כלום.",
        deliverySmsNothingMany: "{n} אורחים לא יקבלו כלום.",
        costLabel: "עלות",
        costCreditsOne: "קרדיט אחד",
        costCreditsMany: "{n} קרדיטים",
        costPerGuest: "קרדיט אחד לכל אורח",
        costPerGuestTicketed: "קרדיט אחד לכל אורח שמקבל את ההודעה בטלפון; אימיילים חינם באירועים עם כרטיסים",
        balanceAfterSending: "יתרה אחרי השליחה: {n}",
        costUnsentNote: "קרדיטים שנשמרו לאורחים שלא יקבלו כלום יחזרו אליכם אחרי השליחה.",
        remindersCostNote: "כל תזכורת עולה קרדיט אחד לכל אורח שהיא מגיעה אליו, בזמן שהיא נשלחת.",
        remindersCostNoteTicketed: "כל תזכורת עולה קרדיט אחד לכל אורח שהיא מגיעה אליו בטלפון, בזמן שהיא נשלחת. אימיילים חינם.",
        notEnoughCreditsToSend: "אין מספיק קרדיטים: יש לכם {balance} וההודעה הזו צריכה {needed}. קנו עוד קרדיטים ושלחו שוב.",

        // Contact editor modal
        contactEditor: "עורך אנשי קשר",
        name: "שם",
        email: "אימייל",
        phone: "טלפון",
        actions: "פעולות",
        addNewContact: "הוסף איש קשר חדש",
        saveContacts: "שמור אנשי קשר",
        cancel: "ביטול",

        // Validation
        contactsCleared: "אנשי הקשר נוקו. כעת ניתן להעלות רשימה חדשה.",

        // Review step labels
        composeYourMessage: "כתוב את ההודעה שלך",
        composeSubtitle: "התאם אישית את ההזמנה ובחר כיצד האורחים יקבלו אותה.",
        messageAndTranslations: "הודעה ותרגומים",
        customEmailSettings: "הגדרות אימייל",
        buttonsLinks: "כפתורים וקישורים",
        linksButtonsLabel: "קישורים / כפתורים",
        buttonsLinksHint: "בחרו עד 2 כפתורים לצירוף להודעה.",
        campaignButtonsMax: "ניתן לכלול עד 2 כפתורים בהודעה",
        buttonCaptionAlsoIn: "נשלח גם ב{n}",
        buttonCaptionAsTyped: "הניסוח שלכם — נשלח בדיוק ככה",
        buttonCaptionPairTip: "שתי השפות מופיעות יחד על הכפתור. אם הצמד ארוך מ-25 תווים שוואטסאפ מתיר, הכפתור חוזר לשפה אחת — הציצו בתצוגה המקדימה כדי לראות את הנוסח המדויק.",
        buttonLabelOptional: "כיתוב הכפתור (לא חובה)",
        buttonAppearsOn: "הכפתורים מופיעים בוואטסאפ ובאימייל.",
        rsvpTargetLabel: "לאן יפנה קישור האישור?",
        rsvpTargetForm: "טופס QuikRSVP",
        rsvpTargetWebsite: "אתר החתונה שלי",
        campaignName: "שם ההודעה",
        campaignNamePlaceholder: "תנו שם להודעה…",
            campaignNameDefaultDescriptor: "הזמנות",
        campaignNameHelp: "תן שם להודעה זו לזיהוי מאוחר יותר",
        campaignNameDuplicate: "כבר קיימת הודעה בשם זה. בחרו שם ייחודי (לדוגמה, הוסיפו ‎ - קבוצה B‎), או הוסיפו אנשי קשר להודעה הקיימת.",
        campaignNameDupShort: "כבר קיימת הודעה בשם זה.",
        campaignNameDupViewExisting: "הצגת ההודעה הקיימת",
        emailSubjectLine: "שורת נושא לאימייל",
        emailSenderName: "שם השולח באימייל",
        emailSenderNameHelp: "השם שהאורחים רואים",
        replyToLabel: "התשובות מגיעות אל",
        replyToDefaultSuffix: "ברירת מחדל",
        replyToAddOption: "שימוש בכתובת אחרת…",
        replyToNewPlaceholder: "name@example.com",
        replyToSendVerify: "שליחת אישור",
        replyToSending: "שולח…",
        replyToSent: "אישור נשלח. פתחו את התיבה, לחצו על הקישור ואז בחרו כאן את הכתובת.",
        replyToRecheck: "אישרתי",
        replyToAlreadyVerified: "הכתובת כבר מאושרת — בחרו אותה מהרשימה.",
        replyToInvalid: "הזינו כתובת אימייל תקינה.",
        replyToError: "לא הצלחנו לשלוח את האישור. נסו שוב.",
        replyToWhyVerify: "אנחנו מאמתים את הכתובת מראש כדי שהזמנות לא יוכלו לנתב תשובות לתיבה שאינה בשליטת השולח.",
        emailThemeColor: "צבע האימייל",
        emailLogo: "לוגו האימייל",
        emailLogoUpload: "העלאה",
        emailLogoHide: "הסתרה",
        emailLogoShow: "הצגה",
        emailLogoReset: "שימוש בלוגו QuikRSVP",
        emailLogoPaidOnly: "מסלולים בתשלום",
        emailLogoUpgradeMsg: "לוגו מותאם אישית זמין במסלולים בתשלום — שדרגו את הטופס כדי להתאים אותו.",
        messageHeader: "כותרת ההזמנה",
        messageHeaderHelp: "כותרת מודגשת בראש האימייל והוואטסאפ שלך. מחקו כדי להסתיר.",
        invitationTagline: "תת-כותרת ההזמנה",
        invitationTaglineHelp: "טקסט קטן מתחת לכותרת (למשל, \"הוזמנתם\"). מחקו כדי להסתיר. (אימייל בלבד)",
        headerAndSubject: "כותרת, תת-כותרת ונושא",
        leaveBlankToHide: "השאירו ריק כדי להסתיר",
        yourMessage: "ההודעה שלך",
        writeMessagePlaceholder: "כתוב את הודעת ההזמנה שלך כאן...",
        characters: "תווים",
        translateTo: "תרגם ל:",
        translate: "תרגם",
        translationWillAppear: "התרגום יופיע כאן...",
        // Message & Translations block (task #453)
        translateHint: "שלחו את ההזמנה גם בשפה נוספת",
        translationsReady: "התרגומים מוכנים",
        messageLanguages: "שפות ההודעה",
        yourMessageBadge: "ההודעה שלכם",
        hide: "הסתר",
        view: "הצג",
        addAnotherLanguage: "הוספת שפה נוספת",
        chooseLanguage: "בחרו…",
        willSendAsWritten: "האורחים יקבלו {a} — ההודעה בדיוק כפי שנכתבה",
        willSendTranslationOnly: "האורחים יקבלו {a} בלבד — המקור לא יישלח",
        willSendBoth: "האורחים יקבלו {a} ו-{b} יחד בהודעה אחת",
        oneTranslationOnly: "הודעה נושאת את המקור שלכם ותרגום אחד. בטלו קודם את {lang}.",
        pickAtLeastOneLanguage: "בחרו לפחות שפה אחת לשליחה.",
        addLanguageToTranslate: "בחרו שפה לתרגום.",
        emptyLanguageBlocked: "הוסיפו טקסט עבור {langs}, או בטלו את סימון השפה.",
        emptyLanguagesBlocked: "הוסיפו טקסט לשפות האלה, או בטלו את סימונן: {langs}.",
        smsNotSendable: "לא ניתן לשלוח כ-SMS",
        smsSourceOnly: "ב-SMS נשלח המקור בלבד",
        smsSendsTranslation: "ב-SMS יישלח התרגום במקום",
        waCombinedOver: "שתי השפות חולקות הודעת וואטסאפ אחת — {n} מתוך 1,024 תווים. קצרו אחת מהן.",
        bothWillBeSent: "המקור והתרגום יישלחו",
        onlyTranslationWillBeSent: "רק התרגום יישלח",
        sendAsWrittenDesc: "ההודעה כבר בשפת האורחים",
        sendTranslatedOnly: "שלח גרסה מתורגמת בלבד",
        bilingual: "דו לשוני",
        sendBilingual: "שלח שניהם (מקור ותרגום) בהודעה אחת",
        multiLanguageHint: "צריך ליצור קשר עם אורחים בשפות שונות בנפרד? צור הודעה לכל שפה.",
        preview: "תצוגה מקדימה",
        addImage: "הוסף תמונה",
        changeImage: "שנה תמונה",
        convertingImage: "ממיר תמונת אייפון…",
        processingImage: "מעבד תמונה…",
        uploadingImage: "מעלה…",
        invitationImage: "תמונת ההזמנה",
        invitationImageDesc: "אופציונלי — מוצגת בראש האימייל והודעת הוואטסאפ.",
        invitationSplashLabel: "פתיחה במסך מלא בלחיצה",
        invitationSplashDesc: "אורחים שילחצו על ההזמנה בוואטסאפ יראו אותה בגודל מלא, ואחריה טופס אישור ההגעה.",
        beforeYouSend: "לפני השליחה",
        goodToKnow: "הערות על קרדיטים ומשלוח",
        optionalLabel: "אופציונלי",
        csvFormattingTips: "טיפים לפורמט CSV",
        downloadTemplate: "הורדת תבנית",
        previewShowsExactly: "התצוגה המקדימה מראה בדיוק מה האורחים יקבלו.",

        // What happens next
        whatHappensNext: "מה קורה אחר כך?",

        // Success states
        campaignCreated: "הודעה נוצרה!",
        messagesQueued: "הודעות בתור",
        scheduledFor: "מתוזמן ל",
        tip: "טיפ",

        // Follow-up reminders step
        followUpRemindersTitle: "תזכורות מעקב",
        followUpRemindersDesc: "תזמן תזכורות אוטומטיות לאורחים שלך",
        saveAndResubmitWhatsApp: "שמירה ושליחה מחדש לוואטסאפ",
        saveAndResend: "שמירה ושליחה מחדש",
        saveAndResubmitHint: "שולח את ההודעה הערוכה חזרה לוואטסאפ לאישור. לאחר האישור היא נשלחת לאורחים שלא קיבלו אותה.",
        saveAndResendHint: "שומר את ההודעה הערוכה ושולח אותה לאורחים שלא קיבלו אותה.",
        // Edit & Resend feedback: the save is instant, the WhatsApp
        // re-submission is not, so they are reported separately (task #592).
        editSavedChanges: "השינויים נשמרו.",
        editSavedResubmitting: "השינויים נשמרו. שולחים את ההודעה לוואטסאפ לאישור…",
        translationStale: "ההודעה שלכם השתנתה אחרי שתורגמה. עדכנו את התרגום.",
        translateAgain: "תרגום מחדש",
        translationStaleBlocked: "שיניתם את ההודעה אחרי שתורגמה. עדכנו את התרגום ל{lang} לפני השליחה: לחצו על תרגום מחדש, או ערכו אותו בעצמכם.",
        translationStaleWarn: "שיניתם את ההודעה אחרי שתורגמה. בדקו שהתרגום ל{lang} עדיין תואם.",
        editSavedRescheduled: "השינויים נשמרו. ההודעה תישלח ב-{date}.",
        editTimingUseSend: "השינויים נשמרו. ההודעה עדיין מתוזמנת ל-{date}. כדי לשלוח אותה עכשיו, לחצו על שליחה.",
        editSavedNotSent: "השינויים נשמרו. עדיין לא נשלח דבר. כדי לשלוח, פתחו את עריכה ושליחה מחדש ולחצו על שליחה.",
        editSavedRescheduledPaused: "השינויים נשמרו. המועד החדש הוא {date}. ההודעה תישאר מושהית עד שתחדשו אותה.",
        editTimingAfterReminder: "תזכורת להודעה הזו מתוזמנת ל-{date}. בחרו מועד מוקדם יותר, או שנו קודם את התזכורת.",
        editTimingPast: "המועד הזה כבר עבר. בחרו מועד עתידי.",
        editTimingPickDate: "בחרו תאריך ושעה לשליחה המתוזמנת.",
        editResubmitAccepted: "ההודעה הערוכה נמצאת בוואטסאפ לאישור. היא תישלח ברגע שתאושר.",
        editResubmitRefused: "וואטסאפ לא קיבלו את ההודעה",
        sendTestSavedAsDraft: "ההודעה נשמרה כטיוטה כדי שנוכל לשלוח את הבדיקה — תמצאו אותה ברשימת ההודעות.",
        editBlockedSending: "השינויים שלכם לא נשמרו: שליחת ההודעה כבר התחילה. כשהשליחה תסתיים, הוסיפו אורחים חדשים בעזרת 'הוספת אנשי קשר' בכרטיס של ההודעה.",
        editBlockedStale: "השינויים שלכם לא נשמרו: ההודעה השתנתה בזמן שערכתם אותה (למשל, נוספו אורחים או שהיא נשלחה). סגרו את החלון ופתחו אותה מחדש כדי לערוך את הגרסה העדכנית.",
        nextFollowUp: "הבא: מעקב",
        addAnotherReminder: "הוסף תזכורת",
        removeReminder: "הסר",
        reminderNumber: "תזכורת",
        whenToSend: "מתי לשלוח",
        sendTo: "למי לשלוח",
        reminderMessage: "הודעה",
        reminderButtonsLabel: "כפתורים",
        reminderButtonRsvp: "קישור לאישור הגעה",
        reminderRsvpAutoIncluded: "(הקישור נכלל אוטומטית)",
        reminderButtonRegistry: "רשימת מתנות",
        reminderButtonDirections: "הוראות הגעה",
        reminderButtonWebsite: "אתר החתונה",
        reminderButtonsHint: "הכפתורים הם רשות — אפשר להוסיף עד 2, או להשאיר ריק כדי לשלוח תזכורת טקסט בלבד.",
        reminderButtonLabelLangHint: "אם משאירים ריק, כל כפתור מופיע בשתי השפות, כפי שמוצג. טקסט שתקלידו יישלח בדיוק כפי שנכתב — כתבו את שתי השפות אם תרצו את שתיהן.",
        reminderEditButton: "עריכה",
        reminderEditTitle: "עריכת תזכורת",
        reminderNewTitle: "תזכורת חדשה",
        reminderLinkedNote: "נשלח כתזכורת מקושרת תחת \"{name}\" — לא כהודעה חדשה.",
        reminderRecipientsFinalized: "הנמענים נקבעים בעת שליחת התזכורת.",
        reminderFixedRecipientsNote: "תזכורת זו תישלח ל-{count} הנמענים שבחרתם.",
        reminderAudienceScopeNote: "מעקב זה יישלח <strong>רק</strong> לנמענים בהודעה הספציפית הזו, ולא לכל אורחי האירוע שלך.",
        reminderSendNowHint: "ברירת המחדל היא עכשיו — היא תישלח בקרוב (לאחר שוואטסאפ יאשר את ההודעה). בחרו תאריך ושעה מאוחרים יותר כדי לתזמן.",
        reminderCancel: "ביטול",
        reminderSaveChanges: "שמירת שינויים",
        reminderCreateBtn: "יצירת תזכורת",
        reminderReviewContinue: "המשך",
        reminderReviewPreviewNote: "מי שתסירו כאן יוסר מהתזכורת הזו בלבד; שאר התזכורות שלכם לא מושפעות. שאר הרשימה נקבעת כשהתזכורת נשלחת — למשל, אורחים שישיבו לפני כן יידלגו אוטומטית.",
        removeButton: "הסר",
        linkChipUrlLabel: "קישור",
        linkChipLabelLabel: "טקסט הכפתור",
        linkChipSave: "הוסף",
        linkChipUrlRequired: "הוסיפו קישור, או בטלו.",
        remindAllTitle: "שליחת תזכורת",
        remindAllSubtitle: "{n} נמענים",
        remindAllPreConfigure: "אין כרגע אורחים מתאימים. התזכורת תישלח אוטומטית לכל מי שיתאים ברגע השליחה.",
        remindAllSendingTo: "נשלח אל <strong>{n}</strong> אורחים נבחרים.",
        remindAllAddedOptedOut: "התזכורות כבויות עבור {n} מהאורחים שהוספתם, ולכן הם לא יקבלו את התזכורת הזו.",
        remindAllContinue: "המשך לשליחה",
        remindAllNextStepHint: "בשלב הבא תבחרו כיצד לשלוח ותאשרו את העלות.",
        reminderUpdatedToast: "התזכורת עודכנה",
        reminderResubmittedToast: "התזכורת עודכנה ונשלחה שוב לאישור WhatsApp.",
        reminderCreatedToast: "התזכורת נוצרה — היא תישלח בזמן שנקבע.",
        reminderSendingNowToast: "התזכורת שלכם בדרך — היא נשלחת עכשיו.",
        reminderUpdateFailed: "עדכון התזכורת נכשל: ",
        reminderCreateFailed: "יצירת התזכורת נכשלה: ",
        reminderAlertPickDateTime: "בחרו תאריך ושעת שליחה.",
        reminderAlertTrailingTag: "ההודעה לא יכולה להסתיים בתגית התאמה אישית כמו {{table_number}} — WhatsApp לא מאפשר זאת. הוסיפו כמה מילים אחריה (למשל \"נתראה שם!\").",
        reminderAlertValidDateTime: "הזינו תאריך ושעה תקינים.",
        reminderAlertRegistryUrl: "הוסיפו כתובת לקישור רשימת המתנות, או בטלו את הסימון.",
        reminderAlertDirectionsUrl: "הוסיפו כתובת לקישור הוראות ההגעה, או בטלו את הסימון.",
        reminderAlertWebsiteUrl: "הוסיפו כתובת לקישור אתר החתונה, או בטלו את הסימון.",
        reminderAlertLivestreamUrl: "הוסיפו קישור לשידור החי, או בטלו את הסימון.",
        reminderSendNowChoice: "לשלוח עכשיו",
        reminderScheduleChoice: "לתזמן למועד מאוחר יותר",
        reminderGoesOutShortly: "התזכורת תישלח בקרוב (לאחר שוואטסאפ יאשר את ההודעה).",
        reminderHourOnlyHint: "התזכורות נשלחות בתחילת השעה (הדקות אינן בשימוש).",
        reminderIncludeImage: "כללו את תמונת ההזמנה",
        reminderImageHeading: "תמונה",
        reminderTranslateLabel: "שלחו גם תרגום ל{lang}",
        reminderTranslateHint: "כבוי כברירת מחדל — התזכורת נשלחת בדיוק כפי שנכתבה. הפעילו כדי לתרגם ולצרף אותה אוטומטית.",
        useDifferentLink: "שימוש בקישור אחר…",
        reminderIncludeThisImage: "כללו את התמונה הזו",
        reminderUseDifferentImage: "השתמשו בתמונה אחרת",
        reminderCustomImageNote: "תזכורת זו משתמשת בתמונה שונה מזו של ההזמנה.",
        reminderButtonsMax: "ניתן לכלול עד 2 כפתורים בכל תזכורת.",
        reminderButtonUrlPlaceholder: "הדביקו קישור (https://...)",
        invalidButtonUrlWarning: "זה לא נראה כמו קישור תקין. אם זו כתובת, הדביקו את הקישור מגוגל מפות — קישורים לא תקינים לא ייכללו בהודעות WhatsApp.",
        reminderDirectionsUrlPlaceholder: "קישור לגוגל מפות או Waze",
        reminderButtonUrlMissing: "הוסיפו קישור לכפתור שנבחר, או בטלו את הבחירה.",
        resetToDefault: "אפס לברירת מחדל",
        guestsWhoHaventRSVPd: "אורחים שלא אישרו הגעה",
        attendingGuests: "אורחים שמגיעים",
        allGuests: "כל האורחים",
        guestsAnsweredMaybe: "אורחים שענו 'אולי'",
        guestsDeclined: "אורחים שהשיבו 'לא'",
        twoWeeksBefore: "שבועיים לפני האירוע",
        oneWeekBefore: "שבוע לפני האירוע",
        threeDaysBefore: "3 ימים לפני האירוע",
        oneDayBefore: "יום לפני האירוע",
        dayOfEvent: "ביום האירוע",
        oneDayAfter: "יום אחרי האירוע",
        threeDaysAfter: "3 ימים אחרי האירוע",
        reminderButtonAlbum: "אלבום תמונות האורחים",
        reminderButtonLivestream: "שידור חי",
        reminderLivestreamUrlPlaceholder: "קישור ל-YouTube, Zoom או Facebook Live",
        reminderAlbumOff: "הפעילו את האלבום בלשונית \"תמונות מהאורחים\" כדי לקבל את הקישור.",
        customDate: "תאריך מותאם",
        pickReminderDate: "בחר תאריך",
        reminderTime: "שעה",
        reminderTimeHint: "יישלח בשעה זו, לפי אזור הזמן המקומי שלך.",
        guestNightWarning: "לתשומת לבך: רבים מהאורחים יקבלו את זה בלילה (בסביבות {time} לפי השעון שלהם). זה יישלח בכל זאת בשעה שבחרת, אבל בשעות היום עונים בדרך כלל מהר יותר.",
        reminderTimePast: "בחר תאריך ושעה עתידיים לתזכורת המותאמת שלך",
        reminderDateInvalid: "תאריך התזכורת חייב להיות ביום האירוע או לפניו",
        reminderDateMissing: "אנא בחר תאריך לתזכורת המותאמת",
        reminderNoEventDate: "לאירוע שלך עדיין אין תאריך, ולכן אפשר לשלוח תזכורת רק בתאריך שתבחר. בחר \"תאריך מותאם\", או הוסף את תאריך האירוע בעורך כדי לתזמן תזכורות לפיו.",
        reminderAfterRsvpDeadline: "אישורי ההגעה ייסגרו לפני מועד התזכורת, ולכן היא לא תישלח. הזז את מועד אישורי ההגעה בעורך, בחר מועד מוקדם יותר או הסר את הקישור לאישור הגעה.",
        defaultReminderMessage: "היי! רק תזכורת ידידותית — נשמח לשמוע ממך! אנא אשר הגעה כשתוכל.",
        defaultAttendingMessage: "מצפים לראות אותך! הנה תזכורת מהירה על פרטי האירוע.",
        defaultMaybeMessage: "היי! ציינת שאולי תגיע/י — הספקת להחליט? נשמח לתשובה סופית, כן או לא, כדי שנוכל להיערך. אנא עדכנ/י את אישור ההגעה כשתוכל/י.",
        creditsChargedNote: "קרדיטים מחויבים כאשר כל תזכורת נשלחת בפועל. וודא שיש לך מספיק קרדיטים ביתרה באותו זמן.",
        skipFollowUpNote: "ניתן לדלג על שלב זה ולשלוח מעקבים מאוחר יותר על ידי יצירת הודעה חדשה מלוח הבקרה.",
        remindersConfigured: "תזכורת/ות מתוזמנ/ות",

        // Toast messages - Payment
        paymentSuccessClickMessage: "התשלום הצליח! לחצו על 'שליחה לאורחים' להמשך.",
        paymentSuccessSendReady: "התשלום הצליח! כעת ניתן לשלוח את ההודעה.",
        paymentSuccessClickContinue: "התשלום הצליח! אנא לחצו על 'שליחה לאורחים' להמשך.",
        paymentSuccessGeneric: "התשלום הצליח!",
        paymentProcessingWait: "אנא המתן בזמן עיבוד הבקשה...",
        paymentSystemUnavailable: "מערכת התשלום לא זמינה. אנא רענן ונסה שוב.",
        paymentCompletedReady: "התשלום הושלם בהצלחה! ההודעה מוכנה לשליחה.",
        paymentSuccessEmoji: "🎉 התשלום הצליח! כעת ניתן לשלוח את ההודעה.",

        // Toast messages - Campaign
        cannotSaveDraftNoEvent: "לא ניתן לשמור טיוטה: לא נבחר אירוע",
        pleaseLoginToSaveDrafts: "אנא התחבר כדי לשמור טיוטות",
        failedToSaveDraft: "שמירת הטיוטה נכשלה. אנא נסה שוב.",
        campaignSentSuccess: "🎉 ההודעה נשלחה! {count} קרדיטים חויבו.",
        insufficientCredits: "אין מספיק קרדיטים. אנא רכוש עוד קרדיטים לשליחת ההודעה.",
        errorProcessingCampaign: "שגיאה בעיבוד ההודעה. אנא נסה שוב.",
        campaignSubmitted: "ההודעה נשלחה! ההודעות יישלחו אוטומטית.",
        campaignScheduledFor: "ההודעה תוזמנה! ההודעות יישלחו ב-{date}.",
        failedToSchedule: "תזמון ההודעה נכשל. אנא פנה לתמיכה.",
        verifyEmailBeforeSending: "יש לאמת את כתובת האימייל לפני השליחה — הזינו את הקוד בלשונית השיתוף בעורך הטופס, ואז שלחו. הקישור כבר עובד עבור האורחים. שום דבר לא נשלח ולא חויב.",

        // Toast messages - Translation
        translationComplete: "התרגום הושלם!",
        translationFailed: "התרגום נכשל. אנא נסה שוב.",
        translationFailedManual: "התרגום נכשל. אנא הזן את התרגום ידנית.",
        messageTranslatedTo: "ההודעה תורגמה ל{language}!",
        translationFailedRetry: "התרגום נכשל. אנא נסה שוב או הזן את ההודעה ידנית.",
        pleaseWriteMessageFirst: "אנא כתוב הודעה קודם",

        // Contact management
        loadFromContacts: "אנשי הקשר שלי",
        noSavedContacts: "אין עדיין אנשי קשר שמורים. אנשי קשר שאתם שולחים אליהם הודעות בקמפיין נשמרים אוטומטית בפנקס הכתובות שלכם.",
        addressBook: "פנקס כתובות",
        addContact: "הוספת איש קשר",
        deleteContactConfirm: "למחוק את איש הקשר הזה מפנקס הכתובות שלכם?",
        edit: "עריכה",
        delete: "מחיקה",
        save: "שמירה",
        contactNeedsInfo: "איש קשר צריך שם וכתובת אימייל או טלפון.",
        importFromPhone: "ייבא מהטלפון",
        importFromPhoneCancelled: "לא נבחרו אנשי קשר.",
        importFromPhoneFailed: "ייבוא אנשי הקשר נכשל: ",
        importFromGoogle: "ייבא מאנשי קשר של Google",
        noGoogleContactsFound: "לא נמצאו אנשי קשר בחשבון Google שלך.",
        googleContactsFailed: "טעינת אנשי הקשר של Google נכשלה: ",
        importFromResponses: "שימוש ברשימת האורחים שלי",
        importFromResponsesTitle: "ייבוא מרשימת האורחים שלכם",
        importFromResponsesSubtitle: "כל מי שברשימת האורחים של האירוע: מי שכבר השיבו ומי שהוספתם ועדיין לא השיבו. אפשר לשלוח הודעות רק למי שיש לו טלפון או אימייל.",
        noRespondersFound: "רשימת האורחים ריקה, אין את מי לייבא.",
        noReachableResponders: "לאף אחד ברשימת האורחים אין טלפון או אימייל, ולכן אין כאן למי לשלוח הודעות.",
        respondersFailed: "לא ניתן לטעון את רשימת האורחים: ",
        respondersUnreachableNote: "לעוד {count} ברשימת האורחים אין טלפון או אימייל, ולכן אי אפשר לשלוח להם הודעות.",
        respondersAlreadyAdded: "כבר ברשימה שלכם",
        rsvpStatusColumn: "תשובה",
        rsvpFilterAll: "כולם",
        rsvpFilterYes: "מגיעים",
        rsvpFilterMaybe: "אולי",
        rsvpFilterNo: "לא מגיעים",
        rsvpFilterWaitlisted: "ברשימת המתנה",
        rsvpFilterPending: "ממתין לתשובה",
        rsvpStatusYes: "כן",
        rsvpStatusMaybe: "אולי",
        rsvpStatusNo: "לא",
        rsvpStatusWaitlisted: "רשימת המתנה",
        rsvpStatusPending: "ממתין לתשובה",
        addMoreContacts: "הוספת אנשי קשר נוספים",
        exportCsv: "ייצוא CSV",
        status: "סטטוס",
        tags: "תגיות",
        allTags: "כל התגיות",
        replaceFile: "החלפת הקובץ",
        maxGuestsCol: "מקס' אורחים",
        maxGuestsColHint: "מספר האורחים המרבי שהזמנה זו יכולה להביא (השאירו ריק כדי להשתמש במגבלת ברירת המחדל של הטופס)",
        // The guest-list columns (task #935)
        guestNamesCol: "שמות האורחים",
        guestNamesColHint: "איך מוסיפים שמות אורחים\n• מפרידים בין שמות בנקודה-פסיק (;). אפשר גם בפסיק.\n• מוסיפים (ילד) אחרי שם של ילד, למשל: יואב כהן (ילד).\n• דוגמה: שרה כהן; מיכאל כהן; יואב כהן (ילד)\n• הטלפון והאימייל בשורה שייכים לאורח הראשון ברשימה.",
        guestNamesPh: "שרה כהן; מיכאל כהן",
        groupNameCol: "שם הקבוצה",
        groupNameColHint: "למי ההזמנה ממוענת, למשל משפחת כהן. השם מופיע על המעטפה ובברכת הטופס; ההודעות פונות לשמות האורחים („היי שרה ומיכאל”).\nלאורח שמוזמן לבד השאירו ריק. אם ממלאים רק את שם הקבוצה, האורחים מוצאים לפיו את ההזמנה ומקלידים את השמות שלהם; עם שמות אורחים, כל אחד מוצא אותה לפי השם שלו.",
        groupNamePh: "משפחת כהן",
        contactPreviewTitle: "כך תיראה ההזמנה",
        contactPreviewEnvelope: "נמען:",
        contactPreviewGreetingLine: "היי {name}",
        contactPreviewLookup: "הקלדה של כל אחד מאלה תמצא את ההזמנה:",
        contactPreviewNoLookup: "הוסיפו שם משפחה או שם קבוצה כדי שהאורח יוכל למצוא את ההזמנה לפי שם.",
        contactPreviewAsksNames: "עדיין אין שמות: מי שימצא את ההזמנה יתבקש למלא את שמות בני הקבוצה.",
        diffSurnamesTip: "טיפ: הוסיפו מספרי טלפון, כתובות אימייל או שמות מלאים לכל אחד מבני הקבוצה, כדי שכל אחד מהם יוכל למצוא בקלות את אישור ההגעה שלו.",
        sameNameWarning: "שימו לב: יש כמה אורחים או קבוצות עם אותו שם. הוסיפו כתובת אימייל או מספר טלפון לכל אחד, כדי שיוכלו לאמת את זהותם בחיפוש ההזמנה.",
        lastFirstFlag: "אדם אחד, שם המשפחה קודם? הפרידו בין אנשים שונים ב-„;”.",
        prefillNameLabel: "למלא מראש את שם האורח בטופס",
        prefillNameDesc: "כל קישור אישי נפתח כששם איש הקשר כבר כתוב בשדה השם (וגם על המעטפה, אם המתג הזה פעיל). כבו זאת אם הרשימה כוללת כינויים או מספרים משותפים — האורחים יקלידו את שמם בעצמם; מגבלות מספר האורחים נשמרות.",
        contactsSelected: "אנשי קשר נבחרו",
        addSelected: "הוסף את הנבחרים",
        selectAll: "בחר הכל",
        importedContactsSummary: "יובאו {added} אנשי קשר. {skipped} דולגו ככפולים.",
        noOrgFound: "לא נמצא ארגון. הגדר את הארגון בלוח הבקרה של הארגון תחילה.",
        noOrgContacts: "לא נמצאו אנשי קשר בארגון. הוסף אנשי קשר בלוח הבקרה של הארגון תחילה.",
        failedToLoadContacts: "טעינת אנשי קשר נכשלה: ",
        selectAtLeastOneContact: "אנא בחר לפחות איש קשר אחד.",
        contactsClearedMessage: "אנשי הקשר נוקו. כעת ניתן להעלות רשימה חדשה.",
        unsavedContactsWarning: "יש אנשי קשר שלא נשמרו. לחץ ביטול כדי לחזור ולשמור, או אישור כדי לבטל את השינויים.",

        // File processing
        unsupportedFileType: "סוג קובץ לא נתמך. אנא העלה קובץ CSV (.csv) או vCard (.vcf).",
        fileAlreadyUploaded: "הקובץ \"{filename}\" כבר הועלה.",
        fileReplaced: "{replaced} אנשי הקשר מהקובץ \"{filename}\" הוחלפו ב-{count} שבקובץ שהעלית עכשיו.",
        fileMergedSummary: "{added} אנשי קשר נוספו מהקובץ \"{filename}\"; {updated} שכבר היו ברשימה עודכנו לפי פרטי הקובץ.",
        failedToProcessFile: "עיבוד הקובץ נכשל. אנא בדוק את הפורמט ונסה שוב.",
        noContactsInFile: "קראנו את \"{filename}\" אבל לא מצאנו בו אנשי קשר.\n\nעמודות שנמצאו: {headers}\n\nלכל איש קשר דרושים כתובת אימייל או מספר טלפון, תחת כותרת שאנחנו מזהים — למשל \"name\", \"email\", \"phone\". שנה את כותרות העמודות בגיליון ונסה להעלות שוב.",
        encodingDamageWarning: "נראה שהקובץ \"{filename}\" איבד את התווים בעברית — השמות מופיעים כ-\"???\" או כתווים משובשים.\n\nזה קורה בדרך כלל כאשר Excel במחשב Mac שומר קובץ csv רגיל. הטקסט המקורי כבר אינו קיים בקובץ, ולכן ייבוא ייצור אנשי קשר עם שמות לא קריאים.\n\nלתיקון: ב-Excel בחרו קובץ ← שמירה בשם ← \"CSV UTF-8 (מופרד בפסיקים)\" והעלו שוב. Google Sheets ו-Numbers מייצאים קבצים תקינים אוטומטית.\n\nלייבא בכל זאת?",
        processingFile: "מעבד את {filename}...",
        missingNamesWarning: "{count} אנשי קשר בלי שם — הם יופיעו כ\"לא ידוע\". אפשר להוסיף שמות ברשימה למטה.",
        // Household invitations (task #908)
        householdCouplesSuggest: "{count} הזמנות נקובות ביותר מאדם אחד, למשל „{example}”. לספור את כל מי שמופיע בהן, עם השמות ממולאים מראש בטופס?",
        householdCouplesYes: "כן, לספור",
        householdNoThanks: "לא, תודה",
        householdFamiliesNote: "{count} הזמנות מיועדות למשפחה, למשל „{example}”. הוסיפו מי מגיע תחת {members} (או קבעו {maxGuests}) כדי שהטופס ימלא את השמות ויספור נכון.",

        // Payment verification modal
        loadingText: "טוען...",
        verifyingPayment: "מאמת סטטוס תשלום...",
        pleaseWaitVerify: "אנא המתן בזמן שאנו מאשרים את השדרוג",
        paymentVerified: "התשלום אומת!",
        paymentProcessing: "התשלום בעיבוד",
        errorVerifyingPayment: "שגיאה באימות התשלום",

        // Contact editor
        validLabel: "תקין",
        checkLabel: "לבדוק",
        toCheck: "לבדיקה",
        phoneCheckChargedNote: "יישלח ויחויב כפי שהוא אם לא יתוקן",
        phoneWarnDoubledCc: "קידומת המדינה מופיעה פעמיים",
        phoneWarnCc927: "927 אינה קידומת מדינה — התכוונתם ל-+972?",
        phoneWarnNanpArea: "במספר +1 קידומת האזור לא יכולה להתחיל ב-0 או ב-1",
        phoneWarnNanpNoCc: "אם זה מספר מארה\"ב או מקנדה, צריך להוסיף +1: {suggest}",
        phoneWarnLength: "למספר נייד +{cc} יש {want} ספרות אחרי קידומת המדינה, ולמספר הזה יש {got}",
        phoneWarnUkPrefix: "מספר נייד +44 מתחיל ב-7",
        phoneWarnIlPrefix: "מספר נייד +972 מתחיל ב-5",
        phoneWarnAssumed: "בלי קידומת מדינה — זוהה כמספר של {country} ({number}); תקנו אם זה לא נכון",
        phoneWarnNeedsCountry: "בלי קידומת מדינה — הוסיפו אותה בהתחלה, למשל ‎+972",
        phoneWarnInvalid: "זה לא מספר תקין ({country}) — בדקו את הספרות",
        phoneWarnInvalidAny: "זה לא מספר טלפון תקין — בדקו את הספרות",
        phoneWarnLandline: "זה קו נייח ({country}) — לא ניתן לשלוח אליו וואטסאפ או SMS",
        phoneCountryLabel: "מספרים בלי קידומת מדינה נקראים כמספרים של",
        phoneCountryHint: "רוב המספרים ברשימה שלכם הם של {country}.",
        phoneCountryUse: "להשתמש ב-{country}",
        contactsLoaded: "אנשי הקשר נטענו",
        countryUnknown: "לא ידוע",
        rowLabel: "שורה",
        deliveryDisclaimer: "אין מסירה של 100%. חלק קטן מההודעות עלול להיעצר בגלל מגבלות השיווק של Meta, מסנני ספקים, תיקיות ספאם או פרטי קשר שגויים — זה מצב רגיל בכל פלטפורמת הודעות.",
        tagsCol: "תגיות",
        tagsColHint: "לאיזו קבוצה שייך האורח, למשל משפחה, קבלת פנים בלבד. הפרידו בין תגיות בפסיקים.\nאם חלק מהאירוע מוגבל לתגיות מסוימות (מוגדר בעורך תחת חלקי האירוע), הקישור האישי של האורח יציג רק את החלקים שמתאימים לתגיות שלו.",
        campaignNameDupAddInstead: "לחצו כאן כדי להוסיף את אנשי הקשר ישירות להודעה הקיימת",
        campaignNameDupAddInsteadSuffix: "במקום זאת",
        progressChecklistTitle: "ההתקדמות שלכם",
        checkCampaignName: "שם ההודעה",
        checkAddContacts: "הוספת אנשי קשר",
        checkCustomizeMessage: "התאמת ההודעה",
        checkConfigureFollowUp: "הגדרת תזכורות",
        checkSendInvitations: "שליחת ההזמנות",
        contactsSummaryTitle: "סיכום אנשי קשר",
        totalGuestsAdded: "סך האורחים שנוספו",
        contactsImported: "אנשי קשר שיובאו",
        needsAttention: "דורש בדיקה",
        supportedImportMethods: "דרכי ייבוא",
        manualEntry: "הזנה ידנית",
        headerOptional: "(אופציונלי)",
        renameTooltip: "שינוי שם",
        gateNoRecipients: "הוסיפו לפחות נמען אחד לפני המעבר לשליחה.",
        gateNoMessage: "כתבו את ההודעה לפני המעבר לשליחה.",
        gateGoToStep: "מעבר לשלב {n}",
        sendStalled: "החיבור לשרתים שלנו נקטע לפני שההודעה נשמרה — שום דבר לא נשלח ולא נוצלו קרדיטים. רעננו את הדף, פתחו שוב את ההודעה ולחצו שוב על שליחה.",
        loadingSites: "טוען את אתרי החתונה שלכם…",
        noWeddingSites: "לא נמצא אתר חתונה.",
        createWeddingSite: "יצירת אתר",
        usingSite: "בשימוש:",
        chooseSite: "בחרו אתר חתונה…",
        siteNotPublished: "יש לפרסם כדי להשתמש",
        noPublishedSite: "אף אחד מאתרי החתונה שלכם עדיין לא פורסם — פרסמו אתר כדי שהאורחים יוכלו לאשר הגעה.",
        rsvpEnabledHint: "ודאו שעמוד אישור ההגעה באתר שלכם מופעל כדי שהאורחים יוכלו להשיב.",
        loadingFollowUp: "טוען הודעת המשך...",
        loadingDraft: "טוען טיוטה...",
        creditsAlreadyEnough: "יש לכם כבר מספיק קרדיטים להודעה הזו — עברו עליה ולחצו על שליחה.",
        remindersSkippedBeforeSend: "{count} תזכורות לא תוזמנו — המועד שלהן לפני שההודעה הזו נשלחת.",
        invalidLabel: "לא תקין",
        verifyCountryCode: "⚠ אמת קידומת מדינה",
        enterGuestName: "הזן שם אורח",
        emailPlaceholder: "name@example.com",
        phonePlaceholder: "+972501234567",
        validContacts: "אנשי קשר תקינים",

        // Scheduling
        scheduledTimePast: "לא ניתן לתזמן לזמן שעבר",
        recipientsLabel: "נמענים",
        noNameLabel: "(ללא שם)",
        removeRecipient: "הסרה",
        removeThisContact: "הסרת איש הקשר",
        allRecipientsRemoved: "כל הנמענים הוסרו. הוסיפו נמענים כדי לשלוח.",
        sendNoFormSelected: "לא נבחר טופס להודעה הזו. פתחו קודם טופס שמור ונסו לשלוח שוב.",
        sendFormNotSaved: "הטופס שלכם עדיין לא סיים להישמר. פתחו אותו שוב בעורך, שמרו ונסו לשלוח שוב.",
        draftSavedFindOnDashboard: "הטיוטה נשמרה. תמצאו אותה בלשונית הודעות בלוח הבקרה.",

        // Misc
        processingButton: "מעבד...",
        personalize: "התאם אישית:",
        demoLabel: "דמו",
        searchContactsPlaceholder: "חפש לפי שם, אימייל או טלפון...",
        loading: "טוען...",

        // New wizard keys
        fullNamePlus: "+ שם מלא",
        firstNamePlus: "+ שם פרטי",
        emailPlus: "+ אימייל",
        tableNumberPlus: "+ מספר שולחן",
        tableTagDisabledHint: "הגדר את מפת ההושבה המובנית כדי להתאים אישית עם מספר השולחן של כל אורח.",
        tableExampleInput: "השולחן שלך הוא {{table_number}}",
        tableSplitNoticeOne: "קבוצה אחת יושבת ביותר משולחן אחד בלי השמות של כל האורחים, ולכן שורת השולחן שלה תיראה כמו \"דנה 2, דנה 3\". הוסיפו את השם של כל אורח ברשימת האורחים כדי שיהיה ברור.",
        tableSplitNoticeMany: "{count} קבוצות יושבות ביותר משולחן אחד בלי השמות של כל האורחים, ולכן שורת השולחן שלהן תיראה כמו \"דנה 2, דנה 3\". הוסיפו את השם של כל אורח ברשימת האורחים כדי שיהיה ברור.",
        clickToInsert: "לחץ להוספה — כל אורח מקבל גרסה מותאמת אישית.",
        seeExample: "ראה דוגמה",
        hideExample: "הסתר דוגמה",
        youWrite: "אתה כותב:",
        exampleInput: "היי {{first_name}}, הוזמנת לאירוע שלנו!",
        eachGuestGets: "כל אורח מקבל:",
        sendTestEmailToMe: "שלח לי קודם אימייל לבדיקה",
        testEmailSending: "שולח אימייל לבדיקה…",
        testEmailSent: "אימייל בדיקה נשלח אל {email}",
        testEmailFailed: "לא ניתן היה לשלוח אימייל בדיקה",
        sendTestTitle: "שלחו לעצמכם בדיקה",
        sendTestSubtitle: "קבלו עותק אמיתי לנייד ולאימייל שלכם, בדיוק כפי שהאורחים יראו.",
        sendTestBtn: "שליחת בדיקה",
        sendTestCostNote: "הבדיקה הראשונה בהודעה הזו בחינם. אחרי זה כל בדיקה ב-SMS או בוואטסאפ עולה קרדיט אחד — בדיקות באימייל תמיד בחינם.",
        sendTestCostAfterFree: "הבדיקה החינמית בהודעה הזו נוצלה. כל בדיקה נוספת ב-SMS או בוואטסאפ עולה קרדיט אחד — בדיקות באימייל נשארות בחינם.",
        sendTestPhoneLabel: "מספר נייד לבדיקה",
        sendTestPhoneHint: "בחשבון שלכם אין מספר נייד, אז הזינו מספר שאליו תישלח הבדיקה. אנחנו נזכור אותו.",
        sendTestPhoneInvalid: "זה לא נראה כמו מספר נייד. השתמשו בפורמט הבינלאומי, למשל +14155550123.",
        sendTestSending: "שולחים את הבדיקה…",
        sendTestDone: "הבדיקה נשלחה אליכם",
        sendTestEmailCopyOnly: "האימייל הוא עותק בשבילכם בלבד — האורחים לא יקבלו אימייל.",
        sendTestFailed: "לא ניתן היה לשלוח את הבדיקה",
        sendTestCreditReturned: "הקרדיט על הבדיקה הזו הוחזר ליתרה שלכם.",
        sendTestEmptyMessage: "כתבו קודם את ההודעה — אין עדיין מה לבדוק.",
        sendTestRoutedToWhatsApp: "המספר אינו אמריקאי, ולכן הבדיקה נשלחת ב-WhatsApp.",
        // A test parked waiting for Meta, and every way that wait can end (task #604).
        sendTestQueued: "הבדיקה שלכם בתור. וואטסאפ עדיין מאשרים את ההודעה — הבדיקה תישלח מעצמה ברגע שתאושר, אז אין מה לעשות כאן.",
        sendTestQueuedSent: "אושר — הבדיקה נשלחה זה עתה לוואטסאפ שלכם.",
        sendTestQueuedFailed: "וואטסאפ אישרו את ההודעה, אבל לא הצלחנו לשלוח את הבדיקה. לחצו על שליחת בדיקה כדי לנסות שוב.",
        sendTestQueuedNoCredits: "וואטסאפ אישרו את ההודעה, אבל לבדיקה שבתור היה דרוש קרדיט ולא היה אף אחד זמין. טענו קרדיטים ולחצו שוב על שליחת בדיקה.",
        sendTestQueuedExpired: "הבדיקה שבתור פגה לפני שוואטסאפ אישרו את ההודעה. לחצו שוב על שליחת בדיקה כדי לשלוח אחת עכשיו.",
        // What the status webhook later says about an accepted WhatsApp test.
        sendTestDelivered: "נמסרה לוואטסאפ שלכם ✓",
        sendTestNotDelivered: "בדיקת הוואטסאפ לא נמסרה",
        sendTestMetaLimit: "הבדיקה לא נמסרה בוואטסאפ: Meta מגבילה את מספר הודעות השיווק שמספר טלפון אחד יכול לקבל, ובדיקות חוזרות עלולות להגיע למגבלה הזו במספר שלכם. הקמפיין והאורחים שלכם לא מושפעים מזה בכלל — אפשר לשלוח בלב שקט. כדי לבדוק שוב כבר עכשיו, שלחו הודעה כלשהי (אפילו רק היי) למספר הוואטסאפ שממנו הגיעה הבדיקה הקודמת, ואז נסו שוב — המגבלה לא חלה בתוך שיחה פתוחה. אחרת, חכו כמה שעות.",
        includeRsvpLink: "כלול קישור אישור הגעה בהודעה",
        rsvpLinkDisabledDesc: "כשמכובה, ההודעה נשלחת ללא קישור לטופס אישור ההגעה.",
        includeQrCode: "כלול קוד QR לצ'ק-אין",
        qrCodeDesc: "אורחים שאישרו הגעה יקבלו קוד QR אישי לצ'ק-אין.",
        qrCodeWhatsappNote: "בוואטסאפ, קוד ה-QR יחליף את תמונת ההודעה.",
        finalCampaignSummary: "סיכום הודעה סופי",
        messagesToSend: "הודעות לשליחה",
        creditsUsed: "קרדיטים בשימוש",
        clickingScheduleNote: "לחיצה על \"תזמן ושלח\" תעביר את ההודעות לתור שליחה.",
        scheduleAndSend: "תזמן ושלח",
        canStillGoBack: "עדיין ניתן לחזור ולערוך לפני השליחה.",
        campaignSentSuccessfully: "ההודעה נשלחה בהצלחה!",
        messagesBeingDelivered: "{count} הודעות בדרך אליכם כעת.",
        windowWillClose: "חלון זה ייסגר אוטומטית...",
        closeButton: "סגור",
        smsConsentAgree: "אני מסכים ל",
        andText: "ו",
        buyMessageCredits: "רכוש קרדיטים להודעות",
        campaignRequires: "ההודעה דורשת:",
        yourBalanceLabel: "היתרה שלך:",
        needLabel: "חסר:",
        selectPackage: "בחר חבילה:",
        bestValue: "הכי משתלם",
        calcHelper: "כמה קרדיטים אני צריך?",
        freeShareBalance: "יש לכם {n} קרדיטים להודעות (כל חשבון מתחיל עם 25 בחינם), והודעת הבדיקה הראשונה שלכם בחינם.",
        freeShareLead: "מעדיפים לשלוח בעצמכם מהטלפון או מהמייל? בלי קרדיטים:",
        freeShareCopy: "העתקת קישור",
        freeSharePersonal: "קישורים אישיים",
        freeShareCopied: "הקישור הועתק",
        calcGuests: "אורחים",
        calcMsgs: "הודעות לכל אחד",
        calcCadence: "רוב המארחים שולחים 3 הודעות לכל אורח: הזמנה, תזכורת, ותזכורת ביום האירוע. תזכורות נשלחות בדרך כלל רק למי שלא ענה, כך שהשימוש בפועל לרוב נמוך יותר.",
        creditsAmount: "{count} קרדיטים",
        creditsMoreAmount: "עוד {count} קרדיטים",
        creditsUnit: "קרדיטים",
        packEnoughForSend: "מספיק להודעה הזו",
        packNeedMore: "חסרים עוד {count}",
        creditsNeverExpireNote: "קרדיטים לא פגים לעולם • לשימוש בכל הטפסים",
        haveEnoughCredits: "יש לכם מספיק קרדיטים!",
        creditsAvailableNeeded: "{balance} קרדיטים זמינים (נדרשים {needed})",
        selectCreditPackage: "בחרו חבילת קרדיטים",
        purchaseStartFailed: "לא הצלחנו להתחיל את הרכישה. נסו שוב.",
        previewNotInteractive: "תצוגה מקדימה — לא אינטראקטיבית",
        emailTab: "אימייל",
        whatsappTab: "וואטסאפ",
        smsTab: "SMS",
        translating: "מתרגם...",
        otherLanguage: "שפה אחרת",
        campaignSubmittedSuccessfully: "ההודעה נשלחה בהצלחה!",
        submittingCampaign: "שולח הודעה...",
        submissionFailed: "השליחה נכשלה",
        submitting: "שולח...",
        errorDetails: "פרטי שגיאה:",
        missingEmailAndPhone: "חסרים אימייל וטלפון",
        invalidEmailFormat: "פורמט אימייל לא תקין",
        invalidPhoneFormat: "פורמט טלפון לא תקין",
        paymentSuccessful: "התשלום הצליח!",
        unknownError: "שגיאה לא ידועה",
        removeImage: "הסר תמונה",
        pendingTranslation: "ממתין לתרגום",
        removeLanguage: "הסר שפה",
        notSpecified: "לא צוין",
    }
};

// Register with dashboard language system if available
if (window.DashboardLanguageSystem) {
    window.DashboardLanguageSystem.registerLanguageContent('he', window.HebrewDashboardContent);
}
